import { number, object, TypeOf } from 'zod';

const PaymentScheme = object({
    plan_id: number().min(1, 'Выберите тариф'),
}).refine(({ plan_id }) => +plan_id > 0);

export type TypePaymentScheme = TypeOf<typeof PaymentScheme>;

export default PaymentScheme;
